import { InputAdornment } from '@mui/material'
import { useState } from 'react'
import { Controller } from 'react-hook-form'

import {
  UButton,
  UCard,
  UIcon,
  UIconButton,
  ULink,
  UStack,
  UText,
  UFormControlInput,
  UAlert,
} from '@src/components'
import { PATHS } from '@src/consts'

import { useSigninForm, useSignin } from './_hooks'

export const SigninMain = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [loginErrors, setLoginErrors] = useState<string[]>([])

  const { signinFormObject } = useSigninForm()

  const {
    handleLoginWithEmailAndPassword,
    isLoadingLoginWithEmailAndPassword,
  } = useSignin({
    setLoginErrors,
    getSigninFormValue: signinFormObject.getValues,
  })

  return (
    <>
      {loginErrors.length > 0 && (
        <UAlert severity="error" className="mb-2">
          {loginErrors.map((error) => (
            <UText key={error}>{error}</UText>
          ))}
        </UAlert>
      )}
      <UCard className="py-7 px-6">
        <form
          onSubmit={signinFormObject.handleSubmit(
            handleLoginWithEmailAndPassword
          )}
        >
          <UStack spacing={3} alignItems="center">
            <Controller
              control={signinFormObject.control}
              name="email"
              render={({ field }) => (
                <UFormControlInput
                  fullWidth
                  error={!!signinFormObject.formState.errors.email}
                  htmlFor="email"
                  required
                  uInputProps={{
                    ...field,
                    helperText:
                      signinFormObject.formState.errors.email?.message,
                    placeholder: 'メールアドレス',
                    InputProps: {
                      autoFocus: true,
                      startAdornment: (
                        <InputAdornment position="start">
                          <UIcon name="email" color="grayDark" />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              )}
            />
            <Controller
              control={signinFormObject.control}
              name="password"
              render={({ field }) => (
                <UFormControlInput
                  fullWidth
                  error={!!signinFormObject.formState.errors.password}
                  htmlFor="password"
                  required
                  uInputProps={{
                    ...field,
                    helperText:
                      signinFormObject.formState.errors.password?.message,
                    placeholder: 'パスワード',
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <UIcon name="lock" color="grayDark" />
                        </InputAdornment>
                      ),
                      type: showPassword ? 'text' : 'password',
                      endAdornment: (
                        <InputAdornment position="end">
                          <UIconButton
                            onClick={() => setShowPassword(!showPassword)}
                            iconProps={{
                              name: showPassword
                                ? 'visibility_off'
                                : 'visibility',
                              color: 'grayDark',
                            }}
                            variant="contained"
                          />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              )}
            />
          </UStack>
          <UStack spacing={3} alignItems="center" className="mt-5">
            <UButton
              size="large"
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              isLoading={isLoadingLoginWithEmailAndPassword}
            >
              ログイン
            </UButton>
            <ULink to={PATHS.RESET_PASSWORD} variant="body2" underline="none">
              <UText color="text.secondary" variant="body2">
                パスワードをお忘れの方
              </UText>
            </ULink>
          </UStack>
        </form>
      </UCard>
    </>
  )
}
